import { jsx as _jsx } from "react/jsx-runtime";
import { checkAppDevopsPermissions } from '@repo/guards/route-checks';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/$application/devops/release-pipeline-board')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const { can, devopsEnabled } = await checkAppDevopsPermissions(queryClient, params.organization, params.project, params.application);
        if (!(can === null || can === void 0 ? void 0 : can.updateApplication) || !devopsEnabled) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/$project/$application/devops/release-pipeline-board'
                }
            });
        }
    },
    component: ()=>/*#__PURE__*/ _jsx(Outlet, {})
});
